<template>
    <!-- TrustBox widget - Mini -->
    <div
        class="trustpilot-widget"
        data-component-name="trust-pilot"
        data-locale="en-US"
        data-template-id="53aa8807dec7e10d38f59f32"
        data-businessunit-id="48fbe7ac000064000503d248"
        data-style-height="150px"
        data-style-width="100%"
        data-theme="light">
        <a
            href="https://www.trustpilot.com/review/www.lendingtree.com"
            target="_blank">Trustpilot</a>
    </div>
    <!-- End TrustBox widget -->
</template>

<script>
    export default {
        mounted() {
            const trustJsScript = document.createElement('script');
            trustJsScript.setAttribute('src', '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js');
            document.head.appendChild(trustJsScript);
        },
    };
</script>

<style lang="scss">
    .trustpilot-widget{
        padding-top: 20px;
        border-bottom: 1px solid #e1e1e1;
    }
</style>
